export const REFERRAL_DASHBOARD_COLUMN_DEFAULT_PAGE = 1
export const REFERRAL_DASHBOARD_COLUMN_DEFAULT_PAGE_SIZE = 50
export const REFERRAL_DASHBOARD_COLUMN_DEFAULT_SORT_PROPERTY = 'created'
export const REFERRAL_DASHBOARD_COLUMN_DEFAULT_SORT_DIRECTION = 'desc'
